const jwtDecode = require('jwt-decode')

const ACCESS_TOKEN_KEY = 'access_token'

export const getToken = () => localStorage.getItem(ACCESS_TOKEN_KEY) || ''

export const setToken = token => localStorage.setItem(ACCESS_TOKEN_KEY, token)

export const getTokenBearer = () => `Bearer ${getToken()}`

export const removeToken = () => localStorage.removeItem(ACCESS_TOKEN_KEY)

export const getUserData = () => {
  let userData = {}
  try {
    userData = { ...jwtDecode(getToken()), trdv: true, lgtp: 'regular' }
  } catch (err) {
    return userData
  }

  return userData
}

export const getAccount = () => getUserData().acc

export const getCpf = () => getUserData().unique_name
